<template>
    <div class="toolbox-footer">
        <v-btn
                v-if="item.step === 1"
                @click.stop="nextStep()"
                class="sr-button"
                text
                :loading="loading"
                :disabled="loading || !item.selectedLayer || !item.selectedVectors.length"
        >
            Weiter
        </v-btn>
        <v-btn
                v-if="item.step === 2"
                @click="save()"
                class="sr-button"
                text
                :loading="loading"
                :disabled="loading"
        >
            Anlegen
        </v-btn>
    </div>
</template>

<script>
  import { VDivider, VCardActions, VBtn } from 'vuetify/lib'

  export default {
    components: {
      VDivider,
      VCardActions,
      VBtn
    },
    props: {
      item: {
        type: Object,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {}
    },
    methods: {
      close () {
        this.$emit('close')
      },
      save () {
        this.$emit('save')
      },
      nextStep () {
        this.item.step++
      }
    }
  }
</script>

<style scoped>

</style>
